<template>
    <div class="staff_list">
        <div class="list_view">
            <div class="table Table_Draggable">
                <el-table :data="tableData" height="100%">
                    <template #empty>
                        <cl-no-data />
                    </template>
                    <el-table-column label="" width="58px">
                        <template slot-scope="{row}">
                            <cl-avatar :src="row.avatar" height="38" width="38" around />
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('team.姓名')" prop="name" :show-overflow-tooltip="true" />
                    <el-table-column :label="$t('club.职务')" prop="job" width="260px" />
                    <el-table-column :label="$t('team.电话')" prop="phone" width="260px" class-name="AkrobatM" />
                    <el-table-column :label="$t('team.邮箱')" prop="email" class-name="AkrobatM" />
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        detailsData: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            tableData: [],
        }
    },
    methods: {
        // 获取数据
        async getData() {
            const params = {
                tenant_id: this.detailsData.tenant_id
            }
            const { code, data } = await this.$server.campStaffListApi(params, this.detailsData.id)
            if (code === 200 && data) {
                this.tableData = data
            }
        },
    },

    created() {
        this.getData()
    },
}
</script>
<style lang="scss" scoped>
.staff_list {
    overflow: hidden;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .list_view {
        flex: 1;
        background: #fff;
        border-radius: 0 0 4px 4px;
        overflow: hidden;
        .table {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
